import { mdiCheck, mdiClose, mdiDelete, mdiPencil, mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import { FunctionComponent, useEffect, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../../../context_providers/toast/toast_ctx";

import ItemSearchFieldV2 from "../../../../../erp/purchase_order/purchase_order_create/components/item_search_widget";
import {
  defaultItem,
  OrderItemModelV2,
} from "../../../../../service/models/orders/order_item_model";
import WarehouseSearchField from "../../../../../erp/inventory/warehouse/warehouse_search_field";
import { WarehouseModel } from "../../../../../erp/inventory/models/warehouse_model";
import ConsumablesSearchField from "../../components/consumables_search_field";

interface ExtraRowWidgetProps {
  extra?: OrderItemModelV2;
  onSubmit: (data: OrderItemModelV2) => void;
  edit: boolean;
  canEdit?: boolean;
  isEditAllowed?: boolean;
  onDelete?: (i: OrderItemModelV2) => void;
  // form_id?: string;
}

const RawMaterialsWidget: FunctionComponent<ExtraRowWidgetProps> = (props) => {
  const { showToast } = useToast();

  const { edit, onSubmit, isEditAllowed } = props;
  const [rawMaterial, setRawMaterial] = useState<OrderItemModelV2>({
    ...(props.extra ?? defaultItem),
  });
  const [editable, setEditable] = useState(false);

    useEffect(() => {
      setEditable(Boolean(edit || isEditAllowed));
    }, [edit, isEditAllowed]);
  const onDone = () => {
    if (!rawMaterial.warehouse_id) {
      showToast({
        type: ToastType.warning,
        text: "Please select warehouse",
      });
      return;
    }

    if (!rawMaterial.item_id || rawMaterial.qty < 1) {
      showToast({
        type: ToastType.warning,
        text: "Please select warehouse, item and qty",
      });
      return;
    }

    if (rawMaterial?.available_qty !== undefined) {
      // if (extra.qty > extra.available_qty ?? 0) {
      // }
      if (rawMaterial.qty && rawMaterial.qty > rawMaterial.available_qty) {
        return showToast({
          type: ToastType.error,
          text: "Filled QTY is greater than Available QTY",
        });
      }
    }
    // if (!extra.price) {
    //   extra.price = 0;
    // }
    onSubmit(rawMaterial);
  };

  return (
    <>
      <form
        // id={props.form_id}
        onSubmit={(e) => {
          e.preventDefault();
          onDone();
        }}
        className="bg-white rounded-md shadow p-5 "
      >
        <div className="grid grid-cols-2 md:grid-cols-7 gap-3 md:items-center">
          <div className="flex flex-col gap-0.5 col-span-2 md:col-span-1">
            <span className="md:hidden text-gray-400 text-xs">Warehouse</span>
            <WarehouseSearchField
              placeholder="Select Warehouse"
              value={rawMaterial.warehouse}
              disabled={!editable}
              onSelect={function (data: WarehouseModel): void {
                if (data) {
                  setRawMaterial((prev) => ({
                    ...prev,
                    warehouse_id: data.id,
                    warehouse: data,
                  }));
                }
              }}
            />
          </div>

          <div className="flex flex-col gap-0.5">
            <span className="md:hidden text-gray-400 text-xs">Item Code</span>
            <input
              value={rawMaterial?.item?.item_code}
              disabled={true}
              onChange={(e) => {}}
              placeholder="Item Code"
              type="text"
              className="text-left  p-1 rounded bg-gray-100 focus:outline-none w-full"
            />
          </div>
          <div className="flex flex-col gap-0.5 col-span-2 md:col-span-1">
            <span className="md:hidden text-gray-400 text-xs">Item</span>
            <ConsumablesSearchField
              warehouse_id={rawMaterial.warehouse_id ?? ""}
              disabled={true}
              placeholder="Select Item"
              value={rawMaterial.item}
              onSelect={(item) => {
                setRawMaterial((o) => ({
                  ...o,
                  item_id: item.id,
                  item,
                  available_qty: item.available_units ?? 0,
                }));
              }}
            />
          </div>
          <div className="flex flex-col gap-0.5 col-span-2 md:col-span-1">
            <span className="md:hidden text-gray-400 text-xs">Description</span>
            <input
              value={rawMaterial?.item?.description}
              disabled={true}
              onChange={(e) => {}}
              placeholder="Item Description"
              type="text"
              className="text-left  p-1 rounded bg-gray-100 focus:outline-none w-full"
            />
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="md:hidden text-gray-400 text-xs">Item Unit</span>
            <input
              value={rawMaterial?.item?.unit?.formal_name ?? "--"}
              disabled={true}
              onChange={(e) => {}}
              placeholder="Item Unit"
              type="text"
              className="text-left  p-1 rounded bg-gray-100 focus:outline-none w-full"
            />
          </div>

          <div className="flex flex-col gap-0.5">
            <span className="md:hidden text-gray-400 text-xs">Quantity</span>
            <input
              value={rawMaterial?.qty}
              onChange={(e) => {
                let v = 0;
                if (e.target.value && !isNaN(e.target.value as any)) {
                  v = Number(e.target.value);
                }
                console.log("Extra On change invoked", rawMaterial);
                if (rawMaterial.available_qty && rawMaterial.available_qty < v)
                  return showToast({
                    type: ToastType.error,
                    text: "Filled QTY is greated than AVAILABLE QTY",
                  });
                setRawMaterial((ol) => ({ ...ol, qty: v }));
              }}
              placeholder=""
              type="number"
              className="text-left  p-1 rounded bg-gray-100 focus:outline-none w-full"
            />
          </div>

          <div className="flex gap-2 items-center justify-center col-span-2 md:col-span-1">
            {isEditAllowed && !props.canEdit && (
              <>
                {props.extra ? (
                  <>
                    <div className="flex justify-center gap-2">
                      {editable ? (
                        <>
                          <div
                            onClick={() => {
                              if (!window.confirm("Are you sure !")) return;
                              onDone();
                              setEditable(false);
                            }}
                            className="bg-green-100 p-1 rounded text-green-800 hover:scale-110 transform duration-200"
                          >
                            <Icon path={mdiCheck} className="h-4 w-4"></Icon>
                          </div>
                          <div
                            onClick={() => {
                              setRawMaterial(props.extra!);
                              setEditable(false);
                            }}
                            className="bg-red-100 p-1 rounded text-red-800 hover:scale-110 transform duration-200"
                          >
                            <Icon path={mdiClose} className="h-4 w-4"></Icon>
                          </div>
                        </>
                      ) : (
                        <div
                          onClick={() => setEditable(true)}
                          className="bg-green-100 p-1 rounded text-green-800 hover:scale-110 transform duration-200"
                        >
                          <Icon path={mdiPencil} className="h-4 w-4"></Icon>
                        </div>
                      )}
                    </div>
                    <div
                      onClick={() => {
                        if (!window.confirm("Are you sure !")) return;
                        if (props.onDelete) props.onDelete(rawMaterial);
                      }}
                      className="bg-red-200 p-1 rounded text-red-800 hover:scale-110 transform duration-200"
                    >
                      <Icon path={mdiDelete} className="h-4 w-4"></Icon>
                    </div>
                  </>
                ) : (
                  <button
                    // form="item_form"
                    className="flex gap-1 text-white text-sm bg-myPrimaryColor rounded-full px-2 py-1 hover:scale-110 transform duration-300"
                  >
                    <Icon path={mdiPlus} className="h-5 w-5 "></Icon> Add
                  </button>
                )}{" "}
              </>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default RawMaterialsWidget;
